<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>

.el-pager li:hover{
	color: #e5284c!important;
}

* {
	  padding: 0;
	  margin: 0;

  }
  body {
	  background: #F6F5F7;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue